"use client";

// Mobile nav toggle — v0.3.1, new.
//
// The sidebar was always fixed-width and always rendered, with zero
// responsive breakpoints (no md:/hamburger anywhere in
// app-sidebar.tsx). At a phone-width viewport the sidebar ate ~60% of
// the screen and pushed real content — e.g. the "Upload footage" button on
// Video Upload — off-screen with no visual cue to scroll. TikTok Shop
// creators filming and uploading from a phone are the most likely real
// users of this exact page, so this was the single most likely real-world
// failure point in the app.
//
// Transient UI state only, not persisted — unlike PersonaProvider, there's no
// reason to remember "sidebar was open" across a reload.

import { createContext, useCallback, useContext, useState } from "react";

interface MobileNavContextValue {
  open: boolean;
  setOpen: (v: boolean) => void;
  toggle: () => void;
}

const MobileNavContext = createContext<MobileNavContextValue | null>(null);

export function MobileNavProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen((o) => !o), []);

  return (
    <MobileNavContext.Provider value={{ open, setOpen, toggle }}>
      {children}
    </MobileNavContext.Provider>
  );
}

export function useMobileNav(): MobileNavContextValue {
  const ctx = useContext(MobileNavContext);
  if (!ctx) throw new Error("useMobileNav must be used inside <MobileNavProvider>");
  return ctx;
}
